<p-confirmDialog [style]="{ width: '450px' }"></p-confirmDialog>

<div class="container-fluid medicine-page">
  <div class="medicine-shell">
    <section class="medicine-toolbar">
      <div class="toolbar-top">
        <div class="toolbar-title">
          <h5 class="mb-0">Medicines</h5>
          <small>{{ filteredMedicines.length }} record(s)</small>
        </div>
        <button type="button" class="btn add-btn" (click)="openDialog()">
          <i class="pi pi-plus me-1"></i>
          Create Medicine
        </button>
      </div>

      <div class="toolbar-controls">
        <div class="search-wrap">
          <i class="pi pi-search"></i>
          <input
            type="text"
            class="form-control"
            placeholder="Search medicine, potency, code..."
            [(ngModel)]="searchTerm"
            (ngModelChange)="onFiltersChanged()"
          />
        </div>

        <div class="filter-dropdown-wrap">
          <p-dropdown
            [options]="scaleFilterOptions"
            [(ngModel)]="scaleFilter"
            optionLabel="label"
            optionValue="value"
            (onChange)="onFilterDropdownChange($event, 'scaleFilter')"
            styleClass="toolbar-filter-dropdown"
            panelStyleClass="toolbar-filter-panel"
            appendTo="body"
          />
        </div>

        <button type="button" class="btn btn-outline-secondary reset-btn" (click)="clearFilters()">
          <i class="pi pi-filter-slash me-1"></i>
          Reset
        </button>
      </div>

      <div class="letter-grid">
        <button
          type="button"
          *ngFor="let letter of letters"
          class="letter-btn"
          [class.active]="selectedLetter === letter"
          (click)="selectLetter(letter)"
        >
          {{ letter }}
        </button>
      </div>
    </section>

    <section class="medicine-table-card">
      <div class="table-responsive">
        <table class="table modern-table mb-0">
          <thead>
            <tr>
              <th>Medicine</th>
              <th>Potency</th>
              <th>Code</th>
              <th>Scale</th>
              <th class="action-cell">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let med of paginatedMedicines">
              <td><span class="med-name">{{ med.name }}</span></td>
              <td>
                <span class="potency-pill">{{ med.potency }}</span>
              </td>
              <td><span class="med-code">{{ med.code || '—' }}</span></td>
              <td>
                <span class="scale-chip" [ngClass]="getScaleClass(med.potency)">
                  {{ getScaleLabel(med.potency) }}
                </span>
              </td>
              <td class="action-cell">
                <div class="action-buttons">
                  <button type="button" class="table-action-btn edit-btn" (click)="startEdit(med)" title="Edit medicine">
                    <i class="pi pi-pencil"></i>
                  </button>
                  <button type="button" class="table-action-btn delete-btn" (click)="confirmDelete(med)" title="Delete medicine">
                    <i class="pi pi-trash"></i>
                  </button>
                </div>
              </td>
            </tr>

            <tr *ngIf="paginatedMedicines.length === 0">
              <td colspan="5" class="text-center py-4 empty-state">
                <i class="pi pi-inbox d-block mb-2"></i>
                No medicines found.
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="table-pagination" *ngIf="filteredMedicines.length > 0">
        <div class="pagination-info">
          Showing {{ paginationStart }} – {{ paginationEnd }} of {{ filteredMedicines.length }}
        </div>
        <div class="pagination-controls">
          <button type="button" class="page-btn" [disabled]="currentPage <= 1" (click)="goToPreviousPage()">
            <i class="pi pi-chevron-left"></i>
          </button>
          <button
            type="button"
            class="page-btn"
            *ngFor="let page of visiblePageNumbers"
            [class.active]="page === currentPage"
            (click)="goToPage(page)"
          >
            {{ page }}
          </button>
          <button type="button" class="page-btn" [disabled]="currentPage >= totalPages" (click)="goToNextPage()">
            <i class="pi pi-chevron-right"></i>
          </button>
        </div>
      </div>
    </section>
  </div>

  <p-dialog
    [header]="medicine.id ? 'Update Medicine' : 'Create Medicine'"
    [(visible)]="displayDialog"
    [modal]="true"
    [style]="{ width: 'min(560px, 94vw)' }"
    [contentStyle]="{ overflow: 'visible', padding: '1rem 1.15rem' }"
    [draggable]="false"
    styleClass="medicine-form-dialog"
    (onHide)="closeForm()"
  >
    <form class="med-dialog-form" #medicineForm="ngForm">
      <section class="med-section-card">
        <header class="med-section-head">
          <span class="med-section-icon" aria-hidden="true"><i class="pi pi-box"></i></span>
          <div>
            <h6>Medicine Details</h6>
            <small>Name and optional identifier</small>
          </div>
        </header>

        <div class="med-field-row">
          <div class="med-field">
            <label class="med-field-label" for="medName">Medicine Name <span class="text-danger">*</span></label>
            <input
              id="medName"
              type="text"
              name="medName"
              class="form-control med-input"
              [(ngModel)]="medicine.name"
              placeholder="Enter medicine name"
              required
            />
          </div>

          <div class="med-field">
            <label class="med-field-label" for="medCode">Medicine Code</label>
            <input
              id="medCode"
              type="text"
              name="medCode"
              class="form-control med-input"
              [class.is-invalid]="codeError"
              maxlength="20"
              [(ngModel)]="medicine.code"
              (input)="onMedicineCodeInput($event)"
              placeholder="e.g. B0001 (optional)"
            />
          </div>
        </div>
        <small class="med-field-hint med-field-hint--full">Leave blank to auto-generate a unique code from the medicine name.</small>
        <small *ngIf="codeError" class="med-field-error med-field-error--full">
          <i class="pi pi-exclamation-triangle"></i> This code is already in use.
        </small>
      </section>

      <section class="med-section-card">
        <header class="med-section-head">
          <span class="med-section-icon med-section-icon--potency" aria-hidden="true"><i class="pi pi-sliders-h"></i></span>
          <div>
            <h6>Potency</h6>
            <small>Select scale and strength</small>
          </div>
        </header>

        <div class="med-field-row">
          <div class="med-field">
            <label class="med-field-label" for="potencyScale">Potency Scale <span class="text-danger">*</span></label>
            <p-dropdown
              id="potencyScale"
              name="potencyScale"
              [options]="potencyScales"
              [(ngModel)]="selectedScale"
              placeholder="Select potency scale"
              optionLabel="label"
              optionValue="value"
              (onChange)="onScaleChange()"
              [showClear]="true"
              styleClass="med-dropdown"
              panelStyleClass="med-dropdown-panel"
              appendTo="body"
            ></p-dropdown>
          </div>

          <div class="med-field">
            <label class="med-field-label" for="potency">Potency <span class="text-danger">*</span></label>
            <p-dropdown
              id="potency"
              name="potency"
              [options]="availablePotencies"
              [(ngModel)]="medicine.potency"
              [placeholder]="selectedScale ? 'Select potency' : 'Select scale first'"
              [disabled]="!selectedScale"
              [filter]="availablePotencies.length > 8"
              [showClear]="true"
              styleClass="med-dropdown"
              panelStyleClass="med-dropdown-panel"
              appendTo="body"
            ></p-dropdown>
          </div>
        </div>
        <small class="med-field-hint med-field-hint--full">Mother Tincture (Ø, Q) · Decimal (X) · Centesimal (C) · LM</small>
      </section>
    </form>

    <ng-template pTemplate="footer">
      <div class="med-dialog-footer">
        <button type="button" class="btn med-cancel-btn" (click)="closeForm()">Cancel</button>
        <button type="button" class="btn med-save-btn" (click)="processMedicine()">
          <i class="pi pi-check me-1"></i>
          {{ medicine.id ? 'Update Medicine' : 'Add Medicine' }}
        </button>
      </div>
    </ng-template>
  </p-dialog>
</div>
